export default __webpack_public_path__ + "static/media/no-image.11dae72f.jpg";